import React, { useEffect, useRef, useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Container, GetInTouchForm, AwardsCarousel} from '../components';
// import AwardsCarousel from './AwardsCarousel';

function WhoWeAre() {
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const videoRef = useRef(null);

    const videoId = 'rB95ju_J4NA';
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    const iframeSrc = `https://www.youtube.com/embed/${videoId}`;

    useEffect(() => {
        const currentVideoRef = videoRef.current;
    
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIframeLoaded(true);
                        observer.unobserve(currentVideoRef);
                    }
                });
            },
            {
                rootMargin: '100px',
            }
        );
    
        if (currentVideoRef) observer.observe(currentVideoRef);
    
        return () => {
            if (currentVideoRef) observer.unobserve(currentVideoRef);
        };
    }, []);

    return (
        <>
        <Container className="who-we-are bg-white">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-14">
                <div className="col-span-full lg:col-start-2 lg:col-end-6">
                    <h2 className="text-3xl mb-6 font-semibold">Who we are</h2>
                    <p>Established in 1998, Holborn Assets are a financial services company with offices in global financial hubs.</p>
                    <p>We specialise in financial advice geared towards the expatriate market, having won multiple awards for our work. We believe in taking an honest, transparent approach to financial management. Doing what is best for our clients is our top priority.</p>
                    <p>Holborn Assets are associated with some of the market-leading investment and money management firms. Because of this, our clients can be sure they have access to the best independent financial advice, and the broadest range of products in the market.</p>
                    <p>Our mission is simple; to offer our clients the expert advice they need to put their money in the right place, at the right time.</p>
                    <div className="mt-4 relative">
                    <div className="aspect-w-16 aspect-h-9 mt-8 h-64 rounded-xl overflow-hidden" ref={videoRef}>
                            {!iframeLoaded ? (
                                <button
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setIframeLoaded(true)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') setIframeLoaded(true);
                                    }}
                                    tabIndex={0}
                                >
                                  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                                    <img
                                        src={thumbnailUrl}
                                        alt="Play Video"
                                        style={{ 
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                </button>
                            ) : (
                                <iframe
                                    title="Holborn Assets Group"
                                    src={iframeSrc}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                    className="w-full h-full"
                                ></iframe>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-span-full lg:col-start-7 lg:col-end-12">
                    <h2 className="text-3xl font-semibold">Get in touch</h2>
                    <div>
                        <GetInTouchForm />
                    </div>
                    <div className="grid grid-cols-12">
                        <div className="col-span-12 lg:col-start-2 lg:col-span-10 flex pt-4">
                            <AwardsCarousel />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
        </>
    )
}

export default WhoWeAre;